import { CXEnvironments } from '~/types/cx-types/cx-environment.types';
import type { GlobalCXContextValue } from '~/components/ClientExperience/providers/global-context/global-cx.context';
import { UnauthenticatedApiService } from '~/services/unauthenticated-api.service';

export class CXNoAuthApiService extends UnauthenticatedApiService {
    globalContext: GlobalCXContextValue = null;

    constructor(globalContext: GlobalCXContextValue) {
        super(globalContext);
        this.globalContext = globalContext;
    }

    protected getBaseUrl() {
        const { clientPortalConfigStore } = this.globalContext;

        if (
            clientPortalConfigStore.env.environment ===
            CXEnvironments.Development
        ) {
            return '/';
        }

        return clientPortalConfigStore.apiBaseUrl;
    }
}
